import { Link } from "react-router-dom";
import Breadcrumb from "@/components/feature/Breadcrumb";
import usePageMeta from "@/hooks/usePageMeta";

const team = [
  { name: "陈默", role: "内容主编", desc: "前娱乐记者，负责选题把关与事实核查。", avatar: "https://readdy.ai/api/search-image?query=Professional%20editorial%20portrait%20silhouette%20style%20abstract%20avatar%20on%20deep%20red%20gradient%20background%2C%20soft%20dramatic%20lighting%2C%20no%20text%2C%20consistent%20palette%2C%20high%20detail&width=200&height=200&seq=team-01&orientation=squarish" },
  { name: "林一可", role: "视频编导", desc: "专注热点事件的视频化叙述与剪辑节奏。", avatar: "https://readdy.ai/api/search-image?query=Professional%20editorial%20portrait%20silhouette%20style%20abstract%20avatar%20on%20warm%20orange%20gradient%20background%2C%20soft%20dramatic%20lighting%2C%20no%20text%2C%20consistent%20palette%2C%20high%20detail&width=200&height=200&seq=team-02&orientation=squarish" },
  { name: "赵启", role: "深度作者", desc: "擅长从行业与商业角度拆解娱乐事件。", avatar: "https://readdy.ai/api/search-image?query=Professional%20editorial%20portrait%20silhouette%20style%20abstract%20avatar%20on%20dark%20crimson%20gradient%20background%2C%20soft%20dramatic%20lighting%2C%20no%20text%2C%20consistent%20palette%2C%20high%20detail&width=200&height=200&seq=team-03&orientation=squarish" },
  { name: "苏晚", role: "视觉设计", desc: "负责封面视觉与栏目的整体风格统一。", avatar: "https://readdy.ai/api/search-image?query=Professional%20editorial%20portrait%20silhouette%20style%20abstract%20avatar%20on%20amber%20and%20red%20gradient%20background%2C%20soft%20dramatic%20lighting%2C%20no%20text%2C%20consistent%20palette%2C%20high%20detail&width=200&height=200&seq=team-04&orientation=squarish" },
];

const values = [
  { icon: "ri-focus-3-line", title: "专注内容本身", desc: "不靠标题党博取点击，用信息密度和梳理质量留住观众。" },
  { icon: "ri-scales-3-line", title: "有据可查", desc: "所有涉及人物与事件的表述，均以公开信息为准，明确标注推测部分。" },
  { icon: "ri-heart-3-line", title: "尊重每一个人", desc: "娱乐之外仍是真实的人，我们拒绝人身攻击与恶意剪辑。" },
];

const milestones = [
  { year: "2021", text: "三人小团队成立，从娱乐剪辑视频起步。" },
  { year: "2023", text: "上线视频资讯站，确立四大内容栏目。" },
  { year: "2025", text: "推出深度解析系列，单期视频平均完播率突破 62%。" },
  { year: "2026", text: "全站累计收录视频超过 12,800 条。" },
];

export default function About() {
  usePageMeta({
    title: "关于我们 - 黑料视频",
    description:
      "了解黑料视频的定位与使命、团队构成与内容准则，以及我们的法律声明与隐私政策说明。",
    keywords: "黑料视频,关于我们,娱乐资讯平台,团队介绍",
  });

  return (
    <div className="w-full">
      {/* Banner */}
      <section className="relative w-full overflow-hidden bg-foreground-950">
        <img
          src="https://readdy.ai/api/search-image?query=Stylized%20abstract%20newsroom%20scene%20with%20deep%20red%20and%20amber%20lighting%2C%20floating%20video%20frames%20and%20glowing%20grid%20lines%2C%20moody%20cinematic%20atmosphere%2C%20no%20text%20no%20faces%2C%20editorial%20poster%20aesthetic%2C%20high%20detail&width=1600&height=640&seq=about-banner&orientation=landscape"
          alt="黑料视频团队与内容理念"
          title="关于黑料视频 - 娱乐视频资讯平台"
          className="absolute inset-0 h-full w-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-foreground-950/90 via-foreground-950/70 to-foreground-950/40"></div>
        <div className="relative mx-auto w-full max-w-[1400px] px-4 py-14 md:px-6 md:py-20">
          <div className="text-background-200">
            <Breadcrumb items={[{ label: "首页", to: "/" }, { label: "关于我们" }]} />
          </div>
          <h1 className="mt-5 max-w-2xl font-heading text-3xl font-black leading-tight text-background-50 md:text-4xl">
            让娱乐新闻，也可以做得克制而专业
          </h1>
          <p className="mt-4 max-w-2xl text-sm leading-relaxed text-background-200 md:text-base">
            黑料视频是一个以视频为主要形态的娱乐资讯平台。我们不满足于把八卦抛给观众，而是希望把每一个热点的来龙去脉讲清楚，让刷屏的每一次都有迹可循。
          </p>
        </div>
      </section>

      {/* Mission */}
      <section className="w-full bg-background-50">
        <div className="mx-auto w-full max-w-[1400px] px-4 py-12 md:px-6 md:py-16">
          <div className="grid grid-cols-1 gap-10 lg:grid-cols-2 lg:items-center">
            <div>
              <span className="inline-flex items-center gap-2 rounded-full bg-primary-50 px-3 py-1 text-xs font-medium text-primary-700">
                <i className="ri-flag-2-line"></i>
                定位与使命
              </span>
              <h2 className="mt-4 font-heading text-2xl font-black text-foreground-950 md:text-3xl">
                为娱乐资讯爱好者，做一份更靠谱的观看清单
              </h2>
              <p className="mt-4 text-sm leading-relaxed text-foreground-600 md:text-base">
                娱乐信息每天以海量速度刷新，观众真正缺的不是内容，而是筛选。黑料视频的价值就在于：把散落各处的公开信息整理成可观看、可追溯的视频条目，让你用更少的时间，获得更完整的理解。
              </p>
              <p className="mt-3 text-sm leading-relaxed text-foreground-600 md:text-base">
                我们坚持三条底线：不编造、不人身攻击、不拿未经证实的消息当事实。这是我们对内容的基本要求，也是对观众的基本尊重。
              </p>
            </div>
            <div className="grid grid-cols-1 gap-3 sm:grid-cols-2">
              {values.map((value) => (
                <div
                  key={value.title}
                  className="rounded-lg border border-background-200 bg-background-100 p-5"
                >
                  <span className="flex h-11 w-11 items-center justify-center rounded-md bg-primary-500 text-background-50">
                    <i className={`${value.icon} text-xl`}></i>
                  </span>
                  <h3 className="mt-3 text-sm font-bold text-foreground-950 md:text-base">
                    {value.title}
                  </h3>
                  <p className="mt-1.5 text-xs leading-relaxed text-foreground-600 md:text-sm">
                    {value.desc}
                  </p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* Team */}
      <section className="w-full bg-background-100">
        <div className="mx-auto w-full max-w-[1400px] px-4 py-12 md:px-6 md:py-16">
          <h2 className="font-heading text-2xl font-black text-foreground-950 md:text-3xl">
            团队简介
          </h2>
          <p className="mt-3 max-w-2xl text-sm leading-relaxed text-foreground-600 md:text-base">
            一支由前媒体从业者、视频编导与内容设计组成的小团队，专注把复杂的热点讲得清楚。
          </p>
          <div className="mt-8 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
            {team.map((member) => (
              <div
                key={member.name}
                className="rounded-lg border border-background-200 bg-background-50 p-5 text-center"
              >
                <div className="mx-auto h-20 w-20 overflow-hidden rounded-full bg-background-200">
                  <img
                    src={member.avatar}
                    alt={`${member.name} 头像`}
                    title={`${member.name} - 黑料视频团队`}
                    className="h-full w-full object-cover object-top"
                  />
                </div>
                <h3 className="mt-4 text-sm font-bold text-foreground-950 md:text-base">
                  {member.name}
                </h3>
                <p className="mt-1 text-xs font-medium text-primary-600">{member.role}</p>
                <p className="mt-2 text-xs leading-relaxed text-foreground-600">{member.desc}</p>
              </div>
            ))}
          </div>

          {/* Milestones */}
          <div className="mt-12">
            <h3 className="font-heading text-lg font-black text-foreground-950">
              一路走来
            </h3>
            <div className="mt-6 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
              {milestones.map((item, i) => (
                <div
                  key={item.year}
                  className="relative rounded-lg border border-background-200 bg-background-50 p-5"
                >
                  <span
                    className={`inline-flex rounded-full px-3 py-1 text-xs font-bold ${
                      i % 2 === 0
                        ? "bg-primary-500 text-background-50"
                        : "bg-accent-500 text-background-50"
                    }`}
                  >
                    {item.year}
                  </span>
                  <p className="mt-3 text-xs leading-relaxed text-foreground-600 md:text-sm">
                    {item.text}
                  </p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* Legal */}
      <section className="w-full bg-background-50">
        <div className="mx-auto w-full max-w-[1400px] px-4 py-12 md:px-6 md:py-16">
          <div className="grid grid-cols-1 gap-6 lg:grid-cols-2">
            <div className="rounded-lg border border-background-200 bg-background-100 p-6">
              <div className="flex items-center gap-3">
                <span className="flex h-10 w-10 items-center justify-center rounded-md bg-secondary-500 text-background-50">
                  <i className="ri-copyright-line text-lg"></i>
                </span>
                <h2 className="font-heading text-lg font-black text-foreground-950">
                  法律声明
                </h2>
              </div>
              <ul className="mt-4 flex flex-col gap-3 text-sm leading-relaxed text-foreground-600">
                <li className="flex gap-2">
                  <i className="ri-checkbox-circle-line mt-0.5 text-primary-500"></i>
                  本站展示的视频与图文均为演示数据，不构成对任何真实人物或事件的认定。
                </li>
                <li className="flex gap-2">
                  <i className="ri-checkbox-circle-line mt-0.5 text-primary-500"></i>
                  站内内容基于公开信息整理，如涉及侵权或事实错误，可通过联系我们页提交更正申请。
                </li>
                <li className="flex gap-2">
                  <i className="ri-checkbox-circle-line mt-0.5 text-primary-500"></i>
                  未经授权，禁止将站内内容用于商业用途或进行二次剪辑传播。
                </li>
              </ul>
            </div>

            <div className="rounded-lg border border-background-200 bg-background-100 p-6">
              <div className="flex items-center gap-3">
                <span className="flex h-10 w-10 items-center justify-center rounded-md bg-secondary-500 text-background-50">
                  <i className="ri-lock-2-line text-lg"></i>
                </span>
                <h2 className="font-heading text-lg font-black text-foreground-950">
                  隐私政策简述
                </h2>
              </div>
              <ul className="mt-4 flex flex-col gap-3 text-sm leading-relaxed text-foreground-600">
                <li className="flex gap-2">
                  <i className="ri-checkbox-circle-line mt-0.5 text-accent-500"></i>
                  浏览本站无需注册，我们不会主动收集你的个人身份信息。
                </li>
                <li className="flex gap-2">
                  <i className="ri-checkbox-circle-line mt-0.5 text-accent-500"></i>
                  通过联系表单提交的内容仅用于回复你的咨询，演示站不会真实发送或存储。
                </li>
                <li className="flex gap-2">
                  <i className="ri-checkbox-circle-line mt-0.5 text-accent-500"></i>
                  你可以随时通过下方邮箱要求删除你主动提交的联系信息。
                </li>
              </ul>
            </div>
          </div>

          <div className="mt-8 flex flex-col items-start gap-4 rounded-lg bg-primary-950 p-6 text-background-100 sm:flex-row sm:items-center sm:justify-between">
            <div>
              <h2 className="font-heading text-lg font-black text-background-50">
                想聊聊内容合作或提供线索？
              </h2>
              <p className="mt-1 text-sm text-background-300">
                我们欢迎提供公开可查的娱乐资讯线索，也接受品牌内容合作。
              </p>
            </div>
            <Link
              to="/contact"
              className="flex shrink-0 items-center gap-2 rounded-md bg-accent-500 px-5 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-accent-600 cursor-pointer whitespace-nowrap"
            >
              <i className="ri-mail-send-line"></i>
              前往联系我们
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
}